// * [Mixins] updateTokenMixin
// * queryがtoken期限切れの場合に自動でrefreshTokenから新しいtokenを取得し再度queryを実行する
// * setup で useQuery から下記を取得し return で返しておく。
// *   refech: updateToken2refech
// *   onError: onError2updateToken
// * ex)
// *   const {result, refech: updateToken2refech, onError: onError2updateToken} = useQuery(...)
// *
import { useMutation } from '@vue/apollo-composable'
import { REFRESH_TOKEN } from '@/graphql'

const updateTokenMixin = {
  setup () {
    // errorによって複数回onErrorが発生するので実行回数を１回にするためのフラグ
    const updateTokenExecFlg = false
    // refreshToken用mutation
    const { mutate: refresh } = useMutation(REFRESH_TOKEN)

    return {
      updateTokenExecFlg,
      refresh
    }
  },
  mounted () {
    /*
    this.onError2updateToken((error) => {
      // authエラー以外なら処理しない
      try {
        if (!error.graphQLErrors[0].message.match(/flask_graphql_auth/)) return
      } catch (e) {
        // 取得できない場合は別のエラー
        this.$store.commit('setError', e)
        return
      }
      if (!this.updateTokenExecFlg) {
        console.log('onError', error)
        this.updateTokenExecFlg = true
        this.refresh({refreshToken: this.$store.state.auth.refreshToken})
          .then(data => {
            console.log(data.data)
            // newToken取得
            this.$store.commit('auth/update', data.data.refresh)
            // queryを再実行
            this.refetch({throwOnError: true, cancelRefetch: true})
            this.updateTokenExecFlg = false
          })
          .catch(err => {
            // 異常終了処理
            this.$store.commit('setError', err)
          })
      } else {
        // console.log('onError skip')
      }
    })
    */
  }
}
export default updateTokenMixin



// WEBPACK FOOTER //
// ./src/mixins/updateTokenMixin.js